export default "__VITE_ASSET__d85e772e__"